import apiClient from './apiClient';
import { asEntityId, cleanObject } from '../utils/commonutils';

const Url = `/followup`;

export const getFollowups = async (props, currentPage ,rowsPerPage ,searchText ,fromDate , toDate
) => {
    try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;

    if (searchText !== null && searchText !== undefined && searchText.trim() !== "") {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }
     if (fromDate !== null && fromDate !== undefined && fromDate.trim() !== "") {
      url += `&fromDate=${encodeURIComponent(fromDate)}`;
    }
    if (toDate !== null && toDate !== undefined && toDate.trim() !== "") {
      url += `&toDate=${encodeURIComponent(toDate)}`;
    }

    let response = await apiClient.get(url);

    return response.data;
  }catch (error) {
        console.log("error", error, error.response);
        return error;
    }
};

export const getFollowupDetail = async (payload, props) => {
    try {
        if (!payload || !payload.followupId) return false;

        let response = await apiClient.get(`${Url}/${payload.followupId}`);

        if (response && response.status === 200) return response.data;
        return response;
    } catch (error) {
        console.log("error", error, error.response);
        return error;
    }
};

export const addFollowup = async (props, Data) => {
    try {
        let body = {
            title:Data?.title,
            date: Data?.date,
            time:Data?.time,
            employeeId: asEntityId(Data?.employee) || asEntityId(Data?.employeeId),
            priority: Data?.priority,
            status:Data?.status,
            note: Data?.note,
            customerId: asEntityId(Data?.customer) || asEntityId(Data?.customerId),
            taskId : Data?.taskId
        };
       const cleanbody = cleanObject(body)
        let response = await apiClient.post(Url, cleanbody);
        return response;
    } catch (error) {
        console.log("error", error, error.response);
        return error;
    }
};

export const editFollowup = async (props, Data , editId) => {
    try {
        let body = {
            title:Data.title,
            date: Data.date,
            time:Data.time,
            employeeId: asEntityId(Data.employee) || asEntityId(Data.employeeId),
            priority: Data.priority,
            status:Data.status,
            note: Data.note,
            ...(asEntityId(Data.customer) || asEntityId(Data.customerId)
                ? { customerId: asEntityId(Data.customer) || asEntityId(Data.customerId) }
                : {}),
        };


        let response = await apiClient.put(
            `${Url}?followUpId=${editId}`,
            body,
        );

        if (response && response.status === 200) return response.data;
        return response;

    } catch (error) {
        console.log("error", error, error.response);
        return error;
    }
};

export const deleteFollwups = async (FollwupId,props) => {
    try{
        if(!FollwupId) return false;
        let response = await apiClient.delete(`${Url}?followUpId=${FollwupId}`);
        return response;
    }catch(error){
        console.log('error', error, error.response);
        return error;
    }
}
